import { render, staticRenderFns } from "./NewTransitionModal.vue?vue&type=template&id=e212dac0&scoped=true&"
import script from "./NewTransitionModal.vue?vue&type=script&lang=ts&"
export * from "./NewTransitionModal.vue?vue&type=script&lang=ts&"
import style0 from "./NewTransitionModal.vue?vue&type=style&index=0&id=e212dac0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e212dac0",
  null
  
)

export default component.exports